/**
 * The screens the native apps floated the corner chat bubble on, ON A PHONE — the first group of the
 * pages that get the sticky chat bar on narrow (`STICKY_CHAT_NARROW_PATHNAMES`).
 *
 * The three, with their native twins:
 *
 *   | pathname              | screen              | iOS                    | Android              |
 *   |-----------------------|---------------------|------------------------|----------------------|
 *   | `/`                   | Home                | `SymphonyHomeView`     | `Pages.kt` home      |
 *   | `/agents`             | Your Agents         | `AgentsScreen`         | `Pages.kt` agents    |
 *   | `/workspace/[slug]`   | a Space's Dashboard | `WorkspaceScreen`      | `Workspace.kt`       |
 */

/**
 * Next.js `router.pathname` PATTERNS (dynamic segments included verbatim, e.g. `[slug]`) — not concrete
 * URLs. Matching the pattern rather than the resolved path is what makes "every Space's dashboard, no
 * Space's Goals tab" one entry instead of a regex.
 */
export const MOBILE_CHAT_LAUNCHER_PATHNAMES: readonly string[] = [
  '/',
  '/agents',
  '/workspace/[slug]',
  // "Agents at work" was merged into the Dashboard tab and this route is now a `router.replace` onto it
  // (see `pages/workspace/[slug]/agents.tsx`). It IS the dashboard, one redirect away, so it carries the
  // bar too.
  '/workspace/[slug]/agents',
];
